const pad = (n: number): string => String(n).padStart(2, '0')

// Data w formacie API (YYYY-MM-DD), liczona z lokalnych pól — bez przesunięć UTC.
export const toApiDate = (date: Date): string =>
    `${date.getFullYear()}-${pad(date.getMonth() + 1)}-${pad(date.getDate())}`

// Miesiąc w formacie API (YYYY-MM).
export const toApiMonth = (date: Date): string =>
    `${date.getFullYear()}-${pad(date.getMonth() + 1)}`
